import SPC_LOGO from "../assets/img/spc_logo.jpg";
import STC_LOGO from "../assets/img/stc_logo.jpg";
import TDMNS_LOGO from "../assets/img/tdmns_logo.png";
import STJOHNS_LOGO from "../assets/img/STJOHNS_LOGO.png";
import SLCS_LOGO from "../assets/img/slcs_logo.jpg";

const COOKIE_KEY = "cb_ecom";

const Api = {
  /*Url :'http://localhost/kalvisalai/stc/php/api/',
	ImageUrl: 'http://localhost/kalvisalai/stc/php/',
	AcademicPath: 'https://admin.sarahtuckercollege.edu.in/api/'*/

  /*Url :'https://christophercollege.kalvisalai.in/webadmin/services/api/',
	ImageUrl: 'https://christophercollege.kalvisalai.in/webadmin/services/',
	AcademicPath: 'christophercollege.kalvisalai.in/webadmin/services/api/'*/

  /*Url :'https://sriparasakthicollege.kalvisalai.in/webadmin/services/api/',
	ImageUrl: 'https://sriparasakthicollege.kalvisalai.in/webadmin/services/',
	AcademicPath: 'https://sriparasakthicollege.kalvisalai.in/webadmin/services/',
	LOGO: '../assets/img/spc_logo.jpg',
	LOGO: SPC_LOGO,*/

  /*Url :'https://webadmin.sarahtuckercollege.edu.in/admin/api/',
	ImageUrl: 'https://webadmin.sarahtuckercollege.edu.in/services/',
	AcademicPath: 'https://webadmin.sarahtuckercollege.edu.in/services/',
	LOGO: STC_LOGO,*/

  /*  Url: "https://webadmin.tdmnscollege.edu.in/services/api/",
  ImageUrl: "https://webadmin.tdmnscollege.edu.in/services/",
  AcademicPath: "https://webadmin.tdmnscollege.edu.in/services/",
  LOGO: TDMNS_LOGO, */

  /*Url: "https://stjohnscollege.kalvisalai.in/api/",
  ImageUrl: "https://stjohnscollege.kalvisalai.in/api/",
  AcademicPath: "https://stjohnscollege.kalvisalai.in/api/",
  LOGO: STJOHNS_LOGO,*/

  Url: "https://naac.slcs.edu.in/api/",
  ImageUrl: "https://naac.slcs.edu.in/api/",
  AcademicPath: "https://naac.slcs.edu.in/api/",
  LOGO: SLCS_LOGO,
};

const DT_Academics = [
  { name: "Programmes", link: "/programmes/ug" },
  { name: "Syllabus", link: "/syllabus/ug" },
  { name: "Course Outcomes", link: "/pso-and-course-outcomes/ug" },
  { name: "Teaching Plan", link: "/teaching-plan" },
];

const DT_Programmes = [
  { name: "UG Programmes", link: "/programmes/ug" },
  { name: "PG Programmes", link: "/programmes/pg" },
  { name: "M.Phil Programmes", link: "/programmes/mphil" },
  { name: "Ph.D Programmes", link: "/programmes/phd" },
];

const DT_Syllabus = [
  { name: "UG Syllabus", link: "/syllabus/ug" },
  { name: "PG Syllabus", link: "/syllabus/pg" },
  { name: "M.Phil Syllabus", link: "/syllabus/mphil" },
];

const DT_Courseoutcomes = [
  { name: "UG Course Outcomes", link: "/pso-and-course-outcomes/ug" },
  { name: "PG Course Outcomes", link: "/pso-and-course-outcomes/pg" },
  { name: "M.Phil Course Outcomes", link: "/pso-and-course-outcomes/mphil" },
];

const DT_CourseMenu = [
  { name: "About", link: "about" },
  { name: "Courses Offered", link: "courses" },
  { name: "Vision & Mission", link: "vision" },
  { name: "Syllabus", link: "syllabus" },
  { name: "POS & Course Outcomes", link: "courseoutcomes" },
  { name: "POS & Teaching Plan", link: "teachingplan" },
  { name: "E-Material", link: "ematerial" },
  { name: "Awards", link: "awards" },
];

const DT_QuickLinks = [
  { name: "Grievances", link: "/grievances" },
  { name: "Mandatory Disclosure", link: "mandatory-disclosure" },
  { name: "Anti Ragging", link: "anti-ragging" },
  { name: "Anti – Harassment", link: "anti-harassment" },
];

export {
  COOKIE_KEY,
  Api,
  DT_Academics,
  DT_Programmes,
  DT_Syllabus,
  DT_Courseoutcomes,
  DT_CourseMenu,
  DT_QuickLinks,
};
